import API from "../api/axios";

// ─── Get All Sales ───
export const getAllSales = () => {
   return API.get("/sales");
};

// ─── Get Single Sale ───
export const getSale = (id) => {
   return API.get(`/sales/${id}`);
};

// ─── Update Sale ───
export const updateSale = (id, data) => {
   return API.put(`/sales/${id}`, data);
};

// ─── Delete Sale ───
export const deleteSale = (id) => {
   return API.delete(`/sales/${id}`);
};

// ─── Get Sales Stats ───
export const getSalesStats = () => {
   return API.get("/sales-stats");
};